import { render, staticRenderFns } from "./FileTreeItem.vue?vue&type=template&id=d4205b8a&scoped=true"
import script from "./FileTreeItem.vue?vue&type=script&lang=js"
export * from "./FileTreeItem.vue?vue&type=script&lang=js"
import style0 from "./FileTreeItem.vue?vue&type=style&index=0&id=d4205b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4205b8a",
  null
  
)

export default component.exports